@if (isLessThanADay) {
  <div>
    <span style="color: #fff">{{ timeMessage() ?? '' | translate }}:&nbsp;</span><b>{{ timeValue() | duration: config }}</b>
  </div>
} @else {
  <span>{{ marketStartTime | momentDate }}</span>
}
@if (debug) {
  <div>Debug: {{ debugInfo }}</div>
}
